import React, { useState } from "react";
import useRecipients from "../hooks/useRecipients";
import { formatRecipient, icons } from "../utils/recipients";

/**
 * Success-screen offer to save the person just paid as a favorite — the moment the sender is
 * already thinking about them. Hidden once they're saved, and for anything but phone/email.
 */
const SaveFavoritePrompt = ({ recipient }) => {
  const { findSaved, save, loaded } = useRecipients();
  const [open, setOpen] = useState(false);
  const [nickname, setNickname] = useState("");
  const [savedName, setSavedName] = useState("");
  const [error, setError] = useState("");

  if (!recipient || !["phone", "email"].includes(recipient.type) || !loaded) {
    return null;
  }
  const existing = findSaved(recipient.value);
  if (existing && !savedName) {
    return null;
  }

  const submit = async () => {
    setError("");
    try {
      await save(recipient, nickname);
      setSavedName(nickname.trim());
    } catch (err) {
      setError(err.response?.data?.detail || "Couldn't save this contact.");
    }
  };

  if (savedName) {
    return (
      <div className="np-card np-save-fav is-done" data-cy="save_favorite_done">
        <span className="np-save-fav-icon">{icons.star(true)}</span>
        <span>
          Saved <b>{savedName}</b>. You'll find them under Send again.
        </span>
      </div>
    );
  }

  return (
    <div className="np-card np-save-fav" data-cy="save_favorite">
      {!open ? (
        <button type="button" className="np-save-fav-open" onClick={() => setOpen(true)}>
          <span className="np-save-fav-icon">{icons.star(false)}</span>
          <span>
            Save {formatRecipient(recipient)} as a favorite
          </span>
        </button>
      ) : (
        <div className="np-save-fav-form">
          <input
            autoFocus
            placeholder="Name, e.g. Mom"
            value={nickname}
            maxLength={100}
            aria-label="Favorite name"
            onChange={(e) => setNickname(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && nickname.trim() && submit()}
          />
          <button
            type="button"
            className="np-inline-action"
            disabled={!nickname.trim()}
            onClick={submit}
          >
            Save
          </button>
        </div>
      )}
      {error && <div className="np-recipient-error">{error}</div>}
    </div>
  );
};

export default SaveFavoritePrompt;
